import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DropdownCardMenu from 'common/components/DropdownCardMenu';

const ProductColumns = ({
    filterData,
    handleClickOnDelete,
    handleClickUpdate,
}) => {
    const { t } = useTranslation();

    let columns = [
        {
            align: 'left',
            display: 'flex',
            field: 'country',
            flex: 1,
            headerName: t('Country'),
            renderCell: (params) => {
                const { row } = params;
                return <>{row.country.name}</>;
            },
            width: 180,
        },
        {
            align: 'left',
            display: 'flex',
            field: 'dp1_name',
            flex: 1,
            headerName: t('State'),
            renderCell: (params) => {
                const { row } = params;
                return <>{row.dp1_name.name}</>;
            },
            width: 180,
        },
        {
            align: 'left',
            display: 'flex',
            field: 'dp2_name',
            flex: 1,
            headerName: t('City'),
            renderCell: (params) => {
                const { row } = params;
                return <>{row.dp2_name.name}</>;
            },
            width: 180,
        },
        {
            align: 'left',
            display: 'flex',
            editable: true,
            field: 'wind_speed',
            flex: 1,
            headerName: t('Wind speed'),
        },
    ];

    columns = [
        ...columns,
        {
            align: 'left',
            display: 'flex',
            field: '',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <DropdownCardMenu
                        items={[
                            {
                                handleClick: () => handleClickUpdate(row),
                                icon: <EditIcon fontSize="small" />,
                                label: t('Edit'),
                            },
                            {
                                handleClick: () =>
                                    handleClickOnDelete(row, filterData),
                                icon: <DeleteIcon fontSize="small" />,
                                label: t('Delete'),
                            },
                        ]}
                    />
                );
            },
            sortable: false,
            width: 100,
        },
    ];

    return columns;
};

ProductColumns.propTypes = {
    filterData: PropTypes.object,
    handleClickOnDelete: PropTypes.func,
    handleClickUpdate: PropTypes.func,
};

export default ProductColumns;
